import * as Sentry from '@sentry/react';

export const init = () => {
    if (!config.SENTRY_DSN) {
        console.log('='.repeat(40));
        console.log('Sentry not initialized');
        console.log('='.repeat(40));
        return;
    }

    Sentry.init({
        dsn: config.SENTRY_DSN,
        release: TAG || 'unknown', // should be match with config
        environment: LEVEL || 'unknown',
        integrations: [],
    });
};

export const captureException = (error: Error) => {
    Sentry.isInitialized() && Sentry.captureException(error);
};

export const setSentryUser = (user: Sentry.User) => {
    Sentry.isInitialized() && Sentry.setUser(user);
};

export const setSentryTag = (key: string, value: string) => {
    Sentry.isInitialized() && Sentry.setTag(key, value);
};
